import httpClientWrapper from '@/helpers/HttpClientWrapper'
import jwtHelper from '@/helpers/JwtHelper'
import IdWraper from '@/model/IdWrapper'


const chatService = {
    getChatThreads: getChatThreads,
    getChatThread: getChatThread,
    sendComment: sendComment,
    markMessagesRead: markMessagesRead,
    deleteMessages: deleteMessages
}

async function getChatThreads() {
    return await httpClientWrapper.get(`/api/chatThreads`, jwtHelper.makeHttpAuthorization())
}

async function getChatThread(chatThreadId) {
    return await httpClientWrapper.get(`/api/chatThreads?chatThreadId=${chatThreadId}`, jwtHelper.makeHttpAuthorization())
}

async function sendComment(commentText, chatThreadId, receiverId) {
    const comment = {
        'message': commentText,
        'chatThreadId': chatThreadId,
        'receiverId': receiverId
    }
    return await httpClientWrapper.post('/api/chatThreads/new', comment, jwtHelper.makeHttpAuthorization())
}

async function markMessagesRead(chatThreadId) {
    return await httpClientWrapper.post('/api/chatThreads/read', new IdWraper(chatThreadId), jwtHelper.makeHttpAuthorization())
}

async function deleteMessages(chatThreadId) {
    return await httpClientWrapper.post('/api/chatThreads/delete', new IdWraper(chatThreadId), jwtHelper.makeHttpAuthorization())
}


export default chatService